import { render, staticRenderFns } from "./Capabilities.vue?vue&type=template&id=50899be5&scoped=true&"
var script = {}
import style0 from "./Capabilities.vue?vue&type=style&index=0&id=50899be5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50899be5",
  null
  
)

export default component.exports